<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-cus-folder" />
      </v-card-title>
    </v-card>
  </div>
</template>
<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  props: {
    comId: {
      default: '',
    },
    noteId: {
      default: '',
    },
    comTp: {
      default: 'DIR',
    },
    isHistory: {
      default: false,
    },
    manage: {
      default: false,
    },
  },
  data() {
    return {
      procIconSize: 24,
      showClose: false,
      dirPath: '',
      foldId: '',
      formEmit: {
        comTp: 'DIR',
        comId: '',
        nodeId: '',
      },
    };
  },
  watch: {
    comId() {
      return this.comId;
    },
  },
  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
    EventBus.$on('updatePathFolder', this.selectFolder);
  },
  mounted() {},
  methods: {
    resetForm() {
      this.dirPath = '';
      this.foldId = '';
      this.formEmit = {
        dirPath: this.dirPath,
        nodeId: this.nodeId,
        foldId: this.foldId,
        comId: this.foldId,
        comName: this.dirPath,
        comTp: this.comTp,
        foldList: this.foldList,
      };
      EventBus.$emit('set-dir-path', this.formEmit);
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.foldId = id;
        if (!this.foldId) {
          this.resetForm();
          return;
        }
        this.selectFolder();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.foldId = this.comId;
        if (this.foldId !== '' && (this.manage || this.isHistory)) {
          this.selectFolder();
        } else {
          this.formEmit = {
            nodeId: this.nodeId,
            comId: '',
            comName: '',
            comTp: this.comTp,
            foldId: '',
            foldList: this.foldList,
            dirPath: '',
          };
          EventBus.$emit('set-dir-path', this.formEmit);
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    selectFolder() {
      if (this.foldId == '0000000000') {
        this.dirPath = '/';
      } else if (this.foldId) {
        let index = this.foldList.findIndex((e) => e.FOLD_ID == this.foldId);
        if (index > -1) {
          this.dirPath = this.foldList[index].FOLD_PATH;
        }
      }
      this.formEmit = {
        nodeId: this.nodeId,
        comId: this.foldId,
        comName: this.dirPath,
        comTp: this.comTp,
        foldId: this.foldId,
        foldList: this.foldList,
        dirPath: this.dirPath,
      };
      EventBus.$emit('set-dir-path', this.formEmit);
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
  },
  computed: {
    foldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          // this.systemFoldList.push(e);
        } else {
          data.push(e);
        }
      });
      return data;
    },
  },
};
</script>
